import { viewportSize } from 'utils/helpers';

export const useProjectForm = () => {
  const {width} = viewportSize()

  return {
    width
  }
}